import { render } from "./UnitsList_unit_address.vue?vue&type=template&id=1257d670&scoped=true"
import script from "./UnitsList_unit_address.vue?vue&type=script&lang=js"
export * from "./UnitsList_unit_address.vue?vue&type=script&lang=js"

import "./UnitsList_unit_address.vue?vue&type=style&index=0&id=1257d670&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1257d670"]])

export default __exports__